<div class="message-confirm" *ngIf="isDeliveryBrojkoConfirmation">
  <h2 class="title">Дякуємо!</h2>
  <b>Ваше замовлення № {{ data.data.order_id }} прийняте</b>
  <b class="alert" *ngIf="data.data.global_settings_status_otgrujaem == 'on' && (data.data.status_otgrujaem || (data.data.settings_status_otgrujaem && data.data.settings_status_otgrujaem == '1'))">Курсова різниця - ризики замовника!</b>
  <b class="text-center alert" *ngIf="!(data.data.global_settings_status_otgrujaem == 'on' && (data.data.status_otgrujaem || (data.data.settings_status_otgrujaem && data.data.settings_status_otgrujaem == '1')))">Неоплачене і незабране замовлення на вказану дату
    самовивізу, буде автоматично розформоване.</b>
  <div class="row">
    <div class="large-4" *ngIf="data.data.delivery == 7">
      <p>Подивитися на Google карті натисни на фото</p>
      <a
        href="https://www.google.com/maps/place/%D0%9C%D0%B0%D1%81%D0%BB%D0%BE%D1%82%D0%BE%D1%87%D0%BA%D0%B0/@50.4121501,30.5089933,17z/data=!3m1!4b1!4m5!3m4!1s0x40d4cf281e881e75:0x27fd3945cff6a97f!8m2!3d50.4121501!4d30.511182"
        target="_blank">
        <img src="/assets/images/brozhka-map.png" alt="brozhka-vidacha">
      </a>
    </div>
    <div class="large-4">
      <p class="text-center">Графік роботи:</p>
      <p class="text-center" [innerHTML]="deliveryCurrent.comment"></p>
      <p class="text-center">{{ deliveryCurrent.address }}</p>
    </div>
    <div class="large-4" *ngIf="data.data.delivery == 7">
      <img src="/assets/images/vidacha.jpg" alt="brozhka-vidacha">
    </div>
  </div>
  <div class="row items-center form_data"
       *ngIf="parseFloat(data.data.calcdebt_summa) > 1 && (
                    parseFloat(data.data.calcdebt_summa) > parseFloat(data.data.delay_summa)
                    || data.data.delay_from && (data.data.delay_from < data.data.delay_days)
              )"
  >
    <div class="column"></div>
    <div class="column shrink textright">
      <b class="comment">
        Прострочена заборгованість!
        <br>
        Відвантаження вашого замовлення можливе після виконання договірних зобов'язань щодо оплати.
      </b>
    </div>
    <div class="column"></div>
  </div>
  <a routerLink="/account" class="button">Ознайомлений</a>
</div>
